import styled from "styled-components";

const StyledModalTitle = styled.h1`
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    color: #1e1e1e;
`;

const StyledModalSubTitle = styled.h3`
    font-weight: 400;
    font-size: 17px;
    line-height: 150%;
    color: #1e1e1e;
    margin: 0 30px 10px 30px;
`;

const StyledModalText = styled.p`
    font-weight: 400;
    font-size: 17px;
    /* margin: 15px 0; */
    color: #000;
`;

const StyledModalAction = styled.p`
    font-weight: 400;
    font-size: 17px;
    margin: 0 10px;
    color: #8a0538;
`;

const StyledGridDiv = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    text-align: left;
`;

const StyledContainerBtns = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 10px;
`;

const StyledIconModalButton = styled.button<{ border?: string }>`
    margin: 15px 0;
    border: none;
    border-bottom: ${({ border }) => (border ? `${border}` : "none")};
    background-color: transparent;
    &:disabled {
        opacity: 0.5;
    }
    &:focus-visible {
        outline: none;
    }
`;

const StyledSelect = styled.select`
    border: 1px solid #8a0538;
    border-radius: 6px;
    margin-left: 15px;
    font-size: 14px;
    width: 85px;
    height: 30px;
    background-color: #f0f2f2;
    &:hover {
        border: 1px solid #8a0538 !important;
    }
    &:active {
        border: 1px solid #8a0538 !important;
    }
    &:focus {
        border: 1px solid #8a0538 !important;
    }
    &:focus-visible {
        border: 1px solid #8a0538 !important;
        outline: none;
    }
`;

const StyledOption = styled.option`
    font-size: 14px;
`;

const StyledEditP = styled.p`
    margin: 0;
    color: #8a0538;
    font-size: 13px;
`;

const StyledSearchInput = styled.div`
    padding: 1.5rem 0;
`;

export default {
    StyledModalTitle,
    StyledModalSubTitle,
    StyledModalText,
    StyledModalAction,
    StyledGridDiv,
    StyledContainerBtns,
    StyledIconModalButton,
    StyledSelect,
    StyledOption,
    StyledEditP,
    StyledSearchInput,
};
